export default [
    {
        path: 'instruments_sales',
        name: 'admin.instruments_sales.index',
        component: require('@/views/admin/instruments_sales/index').default,
        meta: {
            auth: {
                roles: ['manage-customers']
            }
        }
    },
    {
        path: 'instruments_sales/:id',
        name: 'admin.instruments_sales.edit',
        component: require('@/views/admin/instruments_sales/form').default,
        meta: {
            mode: 'edit',
            auth: {
                roles: ['manage-customers']
            }
        }
    },
]
